import { useState, useEffect } from 'react';

import { Company } from '../../../shared/services/api/companies/companies';
import { IRankingCardData } from '../../interfaces/cards';
import { isEmptyObject } from '../../utils/validation/validation';

export const useSelectedBenefitsRanking = (companyId: string) => {
  const [ranking, setRanking] = useState<IRankingCardData>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchSelectedBenefits = async () => {
    setLoading(true);
    try {
      const response = await Company.getSelectedBenefits(companyId);
      if (isEmptyObject(response)) {
        setRanking({});
      } else {
        setRanking(response);
      }
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) {
      fetchSelectedBenefits();
    }
  }, [companyId]);

  return { ranking, loading, error, refetch: fetchSelectedBenefits };
};
